export default __webpack_public_path__ + "static/media/world-cup-two-banner-cn.5e33d8df.webp";